<template>
  <div class="home-View">
    <!-- 顶部导航，pageindex选中项下标从1开始 -->
    <Header :PageIndex="PageIndex"></Header>
    <!-- 首页顶部banner，备考资讯，在线客服，app下载等 -->
    <section class="w1290 homeTop mt30">
      <div class="homeTop-l">
        <!-- 左侧banner -->
        <div class="banner">
          <el-carousel trigger="click" height="380px" autoplay :interval="4000">
            <el-carousel-item v-for="(item, index) in bannerList" :key="index">
              <!-- <img :src="item.pcImage" width="100%" height="100%"> -->
              <el-image
                :src="item.pcImage"
                style="width: 100%; height: 100%"
                class="cursor"
                @click="openBanner(item)"
              >
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 左侧备考资讯 -->
        <div class="PreparationNews">
          <div class="PreparationNews-title">
            <div style="height: 27px; display: flex; align-items: flex-end">
              <img src="../../assets/PreparationNews.png" alt="" />
              <span>备考资讯</span>
            </div>
            <div>
              <a
                @click="$router.push('/testPreparationInformation')"
                class="cursor"
                >更多热点</a
              >
              &gt;
            </div>
          </div>
          <div class="PreparationNews-content clearfix">
            <div
              v-for="(item, index) in InformationList"
              :key="index"
              @click="toInformation(item)"
            >
              <img src="../../assets/listicon.png" />
              <p class="cursor">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="homeTop-r">
        <div class="contactBox cursor">
          <img
            src="../../assets/kefu.png"
            style="width: 297px; height: 257px; border-radius: 4px 4px 0 0"
            class="cursor"
            @click="showContact"
          />
          <div class="contactCodeImg">
            <p>微信扫一扫</p>
            <img src="../../assets/contact.png" style="" alt="" />
          </div>
        </div>

        <div class="menuList">
          <a
            class="cursor"
            v-for="(item, index) in InformationClassifyList"
            :key="index"
            @click="
              $router.push({
                path: '/testPreparationInformation',
                query: { tabId: item.id },
              })
            "
          >
            <img :src="InformationClassifyImg[index]" />
            <div>{{ item.name }}</div>
          </a>
        </div>

        <a href="https://yixue.wendu.com/download/" target="_blank"
          ><img
            src="../../assets/downloadapp.png"
            width="297px"
            height="224px"
            style="margin-top: 20px"
        /></a>
      </div>
    </section>
    <!-- <div class="portions">
      <iframe
        src="https://kefu.ywkefu.com/static/#/pages/index/index?username=null&appId=2594&appSceneId=3023&type=1&deploy=link"
        ref="iframe"
        width="800"
        height="800"
      ></iframe>
    </div> -->

    <section class="w1290 bow">
      <div class="majorSelectBox">
        <nav class="tabs">
          <el-tabs v-model="activeMajorListId" @tab-click="handleClick">
            <el-tab-pane
              :label="item.majorName"
              :name="item.id"
              v-for="(item, index) in majorList"
              :key="index"
            >
              <div class="majorBtnList">
                <div
                  @click="majorChange(majorItem.id)"
                  class="majorButton cursor"
                  :class="[
                    activeMajorId == majorItem.id ? 'activeMajorId' : '',
                  ]"
                  v-for="(majorItem, majorIndex) in item.wdResourcesMajorList"
                  :key="majorIndex"
                >
                  {{ majorItem.majorName }}
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </nav>
      </div>
    </section>

    <!-- 试听直播 -->
    <section class="w1290 AuditionLive" v-if="auditionLivePageList.length > 0">
      <div class="top"><img src="../../assets/AuditionLive.png" /></div>
      <img
        src="../../assets/pageLeft.png"
        class="pageLeft cursor"
        @click="pageLeft"
      />
      <img
        src="../../assets/pageRight.png"
        class="pageRight cursor"
        @click="pageRight"
      />

      <div class="AuditionLiveList">
        <div class="AuditionLiveList-scroll" ref="liveListscroll">
          <div
            class="liveList-item"
            v-for="(item, index) in auditionLivePageList"
            :key="index"
          >
            <img :src="item.teacherImagePhoto" />
            <div class="right">
              <div class="top">
                <div class="kcName">{{ item.liveClassroomName }}</div>
                <div class="tName">讲师：{{ item.teacherName }}</div>
                <div class="time">
                  <img src="../../assets/time.png" />
                  <span>{{ item.liveStartTime }}</span>
                </div>
              </div>
              <div class="bottom">
                <!-- <div class="vytisb" @click="toLive(item)" v-if="item.isAgree == 1">
                  试听
                </div> -->
                <div
                  class="btn cursor"
                  @click="toLive(item)"
                  v-if="item.liveClassroomStatus == 1"
                >
                  待直播
                </div>
                <div
                  class="btn cursor"
                  @click="toLive(item)"
                  v-if="item.liveClassroomStatus == 2"
                  style="
                    background: linear-gradient(
                      90deg,
                      #ff7435 0%,
                      #ff8d45 100%
                    );
                  "
                >
                  直播中
                </div>
                <div
                  class="btn cursor"
                  @click="toLive(item)"
                  v-if="item.liveClassroomStatus == 3"
                  style="background: #c4c8cc"
                >
                  回放生成中
                </div>
                <div
                  class="btn cursor"
                  @click="toLive(item)"
                  v-if="item.liveClassroomStatus == 4"
                  style="
                    background: linear-gradient(
                      90deg,
                      #ffbd2f 0%,
                      #ffc62f 100%
                    );
                  "
                >
                  回放
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pageInfo">
        <div
          v-for="item in auditionLivePageNum"
          :key="item"
          :class="[item == livePage ? 'active' : '']"
        ></div>
      </div>
    </section>

    <!-- 试听课程 -->
    <section
      class="w1290 AuditionCourse"
      v-show="auditionCoursePageList.length > 0"
    >
      <div class="top">
        <img src="../../assets/AuditionCourse.png" />
        <div class="qiehuan">
          <div @click="onShipin" :class="{ shipin2: num == 1, shipin: true }">
            视频
          </div>
          <div class="border"></div>
          <div @click="onZhibo" :class="{ zhibo2: num == 2, zhibo: true }">
            直播
          </div>
        </div>
      </div>

      <div v-if="num == 1" class="AuditionCourseContent">
        <div class="videoBox" id="player"></div>
        <img
          @click="videoListUpDown(1)"
          src="../../assets/videoListUp.png"
          class="videoListUp cursor"
          width="44px"
          height="52px"
        />
        <img
          @click="videoListUpDown(2)"
          src="../../assets/videoListDown.png"
          class="videoListDown cursor"
          width="44px"
          height="52px"
        />

        <div class="videoList">
          <div class="videoListScroll" ref="videoListScroll">
            <div
              class="videoItem"
              v-for="(item, index) in auditionCoursePageList"
              :key="index"
            >
              <div class="topImg cursor" @click="changePlayer(item)">
                <img
                  class="play"
                  src="../../assets/playing.gif"
                  v-if="vid == item.vid"
                />
                <img class="play" src="../../assets/play.png" v-else />
                <img
                  class="cover"
                  :src="item.courseImgPath"
                  :style="{ border: vid == item.vid ? '3px solid #3D7DFF' : 0 }"
                />
              </div>
              <div class="btmText">
                <span
                  :style="{ color: vid == item.vid ? '#3D7DFF' : '#666' }"
                  >{{ item.courseName }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="num == 2" class="AuditionCourseContent">
        <div class="liveBox" @click="toLive(CourseapiList[indexOfL])">
          <img
            class="teacherImagePhoto"
            :src="CourseapiList[indexOfL].teacherImagePhoto"
            alt=""
          />
          <div class="liveBoxFlex">
            <img src="../../assets/zhiobo.png" alt="" />
            直播
          </div>
          <div class="liveBoxenter">
            <img class="play" src="../../assets/play.png" />
            <div>进入直播间</div>
          </div>
        </div>
        <img
          @click="videoListUpDown(1)"
          src="../../assets/videoListUp.png"
          class="videoListUp cursor"
          width="44px"
          height="52px"
        />
        <img
          @click="videoListUpDown(2)"
          src="../../assets/videoListDown.png"
          class="videoListDown cursor"
          width="44px"
          height="52px"
        />

        <div class="videoList2">
          <div class="videoListScrolls" ref="videoListScrolls">
            <div
              class="videoItem"
              v-for="(item, index) in CourseapiList"
              :key="index"
            >
              <div
                class="topImg cursor"
                @click="toLive(item, index)"
                :style="{ border: index == indexOfL ? '3px solid #3D7DFF' : 0 }"
              >
                <div class="liveBoxFlex2">直播</div>
                <img
                  class="play"
                  src="../../assets/playing.gif"
                  v-if="index == indexOfL"
                />
                <img class="play" src="../../assets/play.png" v-else />
                <img class="cover" :src="item.teacherImagePhoto" />
              </div>
              <div class="btmText">
                <span
                  :style="{ color: index == indexOfL ? '#3D7DFF' : '#666' }"
                  >{{ item.liveClassroomName }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 系列课程 -->
    <section class="seriesCourses" v-if="seriesCoursePageList.length > 0">
      <div class="w1290">
        <div class="top"><img src="../../assets/seriesCourses.png" /></div>

        <div class="seriesCoursesContent">
          <div class="leftImg">
            <img src="../../assets/videoLive.png" />
            <p
              class="cursor"
              @click="
                $router.push({
                  path: '/courseList',
                  query: {
                    pId: activeMajorListId,
                    cId: activeMajorId,
                    type: 2,
                  },
                })
              "
              style="color: #3d7dff"
            >
              了解更多
            </p>
          </div>

          <div class="rightCon">
            <div
              class="item cursor"
              v-for="(item, index) in seriesCoursePageList"
              :key="index"
              @click="toCourse(item, 'course')"
            >
              <img
                class="topImg"
                :src="item.classesCover"
                v-if="item.classesCover"
              />
              <img
                class="topImg"
                src="../../assets/42428e3e25aff5ee85120a1f0fbddf2.png"
                v-else
                alt=""
              />
              <!-- <el-image class="topImg" :src="item.classesCover"></el-image> -->
              <div class="center">
                <div class="title">{{ item.classesName }}</div>
                <div class="dsc">{{ item.classesDescribe }}</div>
                <div class="teacherList">
                  <div class="list">
                    <img
                      :src="teacher.teacherImagePhoto"
                      v-for="(teacher, teacherindex) in item.teacherList"
                      :key="teacherindex"
                    />
                  </div>
                  <div class="year">{{ item.academicYear }} 年</div>
                </div>
              </div>
              <div class="bottom">
                <div style="display: flex; align-items: center">
                  <!-- <img src="../../assets/videoType.png" width="88px" height="24px" /> -->
                  <div
                    v-if="item.courseCombination"
                    style="
                      width: 88px;
                      height: 30px;
                      line-height: 30px;
                      text-align: center;
                      color: #ffffff;
                      border-radius: 4px;
                      background: linear-gradient(
                        90deg,
                        #ff6646 0%,
                        #ff9f65 100%
                      );
                      font-size: 14px;
                    "
                  >
                    {{ item.courseCombination }}
                  </div>
                  <span
                    style="font-size: 14px; color: #999999; padding-left: 8px"
                    >{{ item.classHour || "未知" }}节</span
                  >
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: flex-end">
                    <span
                      v-if="item.registrationWay != 1"
                      style="
                        font-size: 14px;
                        color: #fa642c;
                        font-weight: bold;
                        transform: translate(0, 2px);
                      "
                      >￥</span
                    >
                    <span
                      v-if="item.registrationWay == 1"
                      style="font-size: 24px; color: #fa642c"
                      >免费班</span
                    >
                    <span v-else style="font-size: 24px; color: #fa642c">{{
                      item.price | amounts
                    }}</span>
                  </div>
                  <div
                    v-if="item.lineFficialPrice && item.lineFficialPrice != 0"
                    style="
                      font-size: 16px;
                      color: rgba(180, 180, 180, 1);
                      transform: translate(0, 2px);
                      display: flex;
                      align-items: flex-end;
                    "
                  >
                    ￥
                    <div
                      style="
                        font-size: 16px;
                        text-decoration: line-through;
                        color: rgba(180, 180, 180, 1);
                      "
                    >
                      {{ item.lineFficialPrice }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 面授课程 -->
    <section class="w1290 faceCourse" v-if="faceCoursePageList.length > 0">
      <div class="top"><img src="../../assets/faceCourse.png" /></div>

      <div class="seriesCoursesContent">
        <!-- <img src="../../assets/HighEnd.png" /> -->
        <div class="leftImg">
          <img src="../../assets/HighEnd.png" />
          <p
            class="cursor"
            @click="
              $router.push({
                path: '/courseList',
                query: { pId: activeMajorListId, cId: activeMajorId, type: 3 },
              })
            "
            style="color: #00a6cd"
          >
            了解更多
          </p>
        </div>

        <div class="rightCon">
          <div
            class="item cursor"
            v-for="(item, index) in faceCoursePageList"
            :key="index"
            @click="toCourse(item, 'faceCourse')"
          >
            <!-- <img class="topImg" :src="item.classesCover" /> -->
            <img
              class="topImg"
              :src="item.classesCover"
              v-if="item.classesCover"
            />
            <img
              class="topImg"
              src="../../assets/42428e3e25aff5ee85120a1f0fbddf2.png"
              v-else
              alt=""
            />

            <div class="center">
              <div class="title">{{ item.classesName }}</div>
              <div class="dsc">{{ item.classesDescribe }}</div>
              <div class="teacherList">
                <div class="list">
                  <img
                    :src="teacher.teacherImagePhoto"
                    v-for="(teacher, teacherindex) in item.teacherList"
                    :key="teacherindex"
                  />
                </div>
                <div class="year">{{ item.academicYear }}年</div>
              </div>
            </div>
            <div class="bottom">
              <div style="display: flex; align-items: center">
                <!-- <img src="../../assets/videoType.png" width="88px" height="24px" /> -->
                <div
                  v-if="item.courseCombination"
                  style="
                    width: 88px;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    color: #ffffff;
                    border-radius: 4px;
                    background: linear-gradient(
                      90deg,
                      #ff6646 0%,
                      #ff9f65 100%
                    );
                    font-size: 14px;
                  "
                >
                  {{ item.courseCombination }}
                </div>
                <span style="font-size: 14px; color: #999999; padding-left: 8px"
                  >390节</span
                >
              </div>

              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <div style="display: flex; align-items: flex-end">
                  <span
                    v-if="item.registrationWay != 1"
                    style="
                      font-size: 14px;
                      color: #fa642c;
                      font-weight: bold;
                      transform: translate(0, 2px);
                    "
                    >￥</span
                  >
                  <span
                    v-if="item.registrationWay == 1"
                    style="font-size: 24px; color: #fa642c"
                    >免费班</span
                  >
                  <span v-else style="font-size: 24px; color: #fa642c">{{
                    item.price | amounts
                  }}</span>
                </div>
                <div
                  v-if="item.lineFficialPrice && item.lineFficialPrice != 0"
                  style="
                    font-size: 16px;
                    color: rgba(180, 180, 180, 1);
                    transform: translate(0, 2px);
                    display: flex;
                    align-items: flex-end;
                  "
                >
                  ￥
                  <div
                    style="
                      font-size: 16px;
                      text-decoration: line-through;
                      color: rgba(180, 180, 180, 1);
                    "
                  >
                    {{ item.lineFficialPrice }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 专业师资 -->
    <section class="home-lunbo" v-if="teacherList.length > 0">
      <div class="w1290">
        <div class="top"><img src="@/assets/teachers.png" /></div>

        <div class="lunboView-content">
          <div class="leftImg">
            <img
              src="@/assets/teachersimg.png"
              style="width: 240px; height: 415px"
            />
            <p
              class="cursor"
              @click="$router.push('/teachers')"
              style="color: #00bcae"
            >
              了解更多
            </p>
          </div>

          <div class="lunbo-teachers-left rightCon">
            <el-carousel
              :interval="4000"
              height="422px"
              indicator-position="outside"
              arrow="never"
            >
              <el-carousel-item
                v-for="(item, index) in teacherList"
                :key="index"
                class="teachers-list"
              >
                <div class="teachers-item" v-for="_ in item" :key="_.id">
                  <img :src="_.imagePhoto" class="teachers-img" />
                  <div class="context">
                    <p class="teacher-name">
                      <span class="name">{{ _.name }}</span>
                      <span class="academicDegree">{{ _.title }}</span>
                    </p>
                    <p class="teacher-text">{{ _.introduce }}</p>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </section>

    <!-- 配套资料 -->
    <section class="w1290 supportingInformation" v-if="bookList.length > 0">
      <div class="top" style="margin-bottom: 22px">
        <img src="../../assets/supportingInformation.png" />
      </div>

      <div class="seriesCoursesContent">
        <div style="position: relative" class="leftImg">
          <img src="../../assets/Textbook.png" />
          <p
            class="cursor"
            @click="$router.push({ path: '/bookMall' })"
            style="color: #ff7619"
          >
            了解更多
          </p>
          <!-- <p class="cursor" @click="$router.push({path: '/bookMall', query: {pId: activeMajorListId,cId: activeMajorId,}})" style="color: #FF7619">了解更多</p> -->
        </div>

        <div class="rightCon">
          <div
            class="item cursor"
            v-for="item in bookList"
            :key="item.id"
            @click="toBookDetail(item)"
          >
            <div class="topImg">
              <img :src="item.image" />
            </div>

            <div class="center">
              <div class="boolName pass_2line_hidden">{{ item.bookName }}</div>
              <div class="bookprice">
                ￥<span>{{ item.officalPrice | amounts }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="aboutwd">
      <div class="w1290">
        <div class="title">关于文都</div>
        <div class="aboutwxContent">
          <div class="left">
            <p class="line"></p>
            <div>
              文都教育科技集团（以下简称为文都教育）是专注为以大学生为主体的Y12人群提供升学、就业和职业技能提升的专业化智慧教育平台。公司总部位于北京市海淀区中关村高科技园区，业务覆盖研究生教育、公职教育、医学教育、艺术教育、IT教育、法律教育、财经教育、专升本、出国留学和校企合作等教育培训领域。文都教育以精彩课程、优质资料、专业服务、前沿技术、科学管理及全方位品牌建设，已成为备受大学生欢迎的品牌。基于移动互联网、人工智能、大数据、云计算等技术的应用，文都教育打造以文都教育大数据、文都智能学习系统、文都教育新生态为核心的文都智慧教育体系。
            </div>
          </div>

          <p class="line"></p>

          <div class="right">
            <div class="r-item">
              <img src="../../assets/aboutwd1.png" />
              <div><span>近20</span>年</div>
              <p>专注教育</p>
            </div>
            <div class="r-item">
              <img src="../../assets/aboutwd2.png" />
              <div><span>近30</span>个省份</div>
              <p>覆盖全国</p>
            </div>
            <div class="r-item">
              <img src="../../assets/aboutwd3.png" />
              <div><span>1000</span>+</div>
              <p>拥有教学服务团队</p>
            </div>
            <div class="r-item">
              <img src="../../assets/aboutwd4.png" />
              <div><span>1100</span>+</div>
              <p>累计申请知识产权</p>
            </div>
          </div>
        </div>

        <div class="liaojie cursor" @click="$router.push('/aboutUs')">
          了解更多 &gt;
        </div>

        <el-carousel
          :interval="4000"
          indicator-position="none"
          arrow="never"
          v-if="StudentCommentList.length > 0"
        >
          <el-carousel-item
            v-for="item in StudentCommentList"
            :key="item.id"
            class="assess-list"
          >
            <div
              class="assess-item"
              v-for="(comment, index) in item"
              :key="index"
            >
              <img :src="comment.phoneImage" class="teachers-img" />

              <div class="content">
                <p class="username">{{ comment.studentName }}</p>
                <div class="line"></div>
                <div class="text">{{ comment.comment }}</div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </section>

    <Footer></Footer>
    <!-- <PositionRight></PositionRight> -->

    <!-- 验证码登录没密码设置密码 -->
    <el-dialog
      style="min-width: 30%"
      title="设置新密码"
      :visible.sync="passwordDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="35%"
    >
      <div class="bindPhoneDialog">
        <div class="phoneCode">
          <input
            type="text"
            disabled
            placeholder="手机号"
            v-model="passwordDialog.phone"
          />
        </div>
        <div class="phoneCode">
          <input
            type="password"
            placeholder="密码6位及以上，数字、字母、符号任意两种"
            v-model="passwordDialog.newPassword"
          />
        </div>
        <div class="phoneCode">
          <input
            type="password"
            placeholder="确认密码"
            v-model="passwordDialog.confirmPassword"
          />
        </div>
        <div @click="settingComplete" class="btn cursor">设置完成</div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
</script>

<script>
import Header from "@/components/header/header.vue";
import Footer from "@/components/footer/footer.vue";
import PositionRight from "@/components/positionRight/positionRight.vue";
import { setMajorId, getMajorId } from "@/utils/index.js";
import regextool from "@/utils/util.js";
import { settingPassword } from "@/api/login.js";
import { addCourseRecord } from "@/api/learn.js";
import {
  getBanner,
  getMajorList,
  getAuditionLivePageList,
  getAuditionCoursePageList,
  getSeriesCoursePageList,
  getFaceCoursePageList,
  getStudentCommentList,
  getInformationList,
  getInformationClassifyList,
  getTeacherList,
  getLiveUrl,
  getPolyvFindByToken,
  getCourseapiList,
} from "@/api/home.js";
import { getbookMallList } from "@/api/bookMall.js";
export default {
  components: {
    Header,
    Footer,
    PositionRight,
  },
  name: "index",
  data() {
    return {
      num: 1, //切换试听直播与试听视频
      passwordDialogVisible: false,
      // 设置密码弹框信息
      passwordDialog: {
        phone: "",
        newPassword: "",
        confirmPassword: "",
        type: "1",
      },
      InformationClassifyImg: [
        require("../../assets/menu1.png"),
        require("../../assets/menu2.png"),
        require("../../assets/menu3.png"),
        require("../../assets/menu4.png"),
        require("../../assets/menu5.png"),
        require("../../assets/menu6.png"),
      ],
      PageIndex: 1,
      livePage: 1,
      livePageLeft: 0,
      isLivePageScrollNow: false,
      videoPage: 1,
      videoPageTop: 0,
      isVideoPageScrollNow: false,
      InformationList: [], // 资讯
      InformationClassifyList: [], //资讯分类
      activeMajorListId: "", //专业 父级id
      activeMajorId: "", //专业下 子id
      majorList: [], //专业
      bannerList: [], //banner
      auditionLivePageList: [], //试听 视频
      CourseapiList: [], //试听 直播
      auditionLivePageNum: 1, //试听 直播
      auditionLivePageNumqwe: 1, //试听 直播

      auditionCoursePageList: [], //试听 课程
      auditionCoursePageNum: 1, //试听 课程

      seriesCoursePageList: [], //系列 课程
      faceCoursePageList: [], //面授 课程

      StudentCommentList: [], //学员评价

      teacherList: [],
      bookList: [],
      noneImg: require("@/assets/42428e3e25aff5ee85120a1f0fbddf2.png"),
      vodPlayerJs: "https://player.polyv.net/resp/vod-player/latest/player.js", //视频播放器
      vid: "", //视频vid
      contactImg: require("../../assets/contact.png"),
      indexOfL: 0,
      obj: {
        majorId: "",
        pageNo: 1,
        pageSize: 6,
      },
      obj2: {
        majorId: "",
        pageNo: 1,
        pageSize: 6,
      },
    };
  },
  created() {


    (function (w, d, n, a, j) {
      w[n] =
        w[n] ||
        function () {
          (w[n].a = w[n].a || []).push(arguments);
        };
      j = d.createElement("script");
      j.async = true;
      j.src = "https://kefu.ywkefu.com/static/js/ywkefu_sdk.js";
      var s = d.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(j, s);
    })(window, document, "ywkf");
    ywkf("config", {
      appSceneId: 3023,
    });



    // 获取专业列表
    getMajorList().then((res) => {
      if (res.data.code == 200) {
        if (res.data.result.length > 0) {
          this.majorList = res.data.result;
          this.activeMajorListId = res.data.result[0].id;
          this.activeMajorId = res.data.result[0].wdResourcesMajorList[0].id;
          setMajorId(res.data.result[0].wdResourcesMajorList[0].id);
          this.getAuditionLivePageList(this.activeMajorId);
          // this.obj2.majorId = this.activeMajorId
          // this.getCourseapiList(this.obj2);
          this.obj.majorId = this.activeMajorId;
          this.getAuditionCoursePageList(this.obj);
          this.getSeriesCoursePageList(this.activeMajorId);
          this.getFaceCoursePageList(this.activeMajorId);
          this.getTeacher();
          this.getbookMallList();
        }
      }
    });
    //资讯分类
    getInformationClassifyList().then((res) => {
      if (res.data.code == 200 && res.data.result.records.length > 0)
        this.InformationClassifyList = res.data.result.records;
    });
    // 资讯
    getInformationList().then((res) => {
      if (res.data.code == 200 && res.data.result.records.length > 0) {
        this.InformationList = res.data.result.records;
      }
    });
    // banner
    getBanner().then((res) => {
      if (res.data.code == 200 && res.data.result.length > 0) {
        this.bannerList = res.data.result;
      }
    });

    this.getStudentCommentList();
  },
  mounted() {
    // this.loadPlayerScript(this.loadPlayer);
    const userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    if (!userInfo.userPassword) {
      this.passwordDialog.phone = userInfo.stuPhone;
      this.passwordDialogVisible = true;
    }
  },
  methods: {
    onShipin() {
      this.videoPage = 1;
      this.videoPageTop = 0;
      this.isVideoPageScrollNow = false;

      console.log(this.videoPage);
      console.log(this.videoPageTop);
      console.log(this.isVideoPageScrollNow);
      this.obj.pageNo = 1;
      this.activeMajorId = getMajorId();
      this.obj.majorId = this.activeMajorId;
      // this.auditionCoursePageList = []

      this.getAuditionCoursePageList(this.obj, 1);
      this.num = 1;
    },
    onZhibo() {
      this.videoPage = 1;
      this.videoPageTop = 0;
      this.isVideoPageScrollNow = false;

      this.obj2.pageNo = 1;
      this.activeMajorId = getMajorId();
      this.obj2.majorId = this.activeMajorId;
      this.CourseapiList = [];

      // this.$refs.videoListScrolls.style.webkitTransform = `translate(0, ${0}px) scale(1) translateZ(0px)`;
      this.getCourseapiList(this.obj2, 1);
      this.num = 2;
    },
    // 设置密码完成
    settingComplete() {
      if (
        !regextool.checkPwdly(this["passwordDialog"].newPassword) ||
        !regextool.checkPwdly(this["passwordDialog"].confirmPassword)
      ) {
        this.$message.warning("密码应6位及以上，数字、字母、符号任意两种");
        return;
      }
      if (
        this["passwordDialog"].newPassword !==
        this["passwordDialog"].confirmPassword
      ) {
        this.$message.warning("请确认前后密码一致");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "请求中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const data = {
        newPassword: this["passwordDialog"].newPassword,
        confirmPassword: this["passwordDialog"].confirmPassword,
        type: "1",
      };
      settingPassword(data)
        .then((res) => {
          console.log(res, "设置密码");
          loading.close();
          if (res.data.code == 200) {
            this.passwordDialogVisible = false;
            this.$message.success(res.data.message);
          }
        })
        .catch((err) => {
          loading.close();
        });
    },
    toBookDetail(item) {
      const { href } = this.$router.resolve({
        path: "/bookDetail",
        query: {
          id: item.id,
        },
      });
      window.open(href, "_blank");
    },
    getbookMallList() {
      getbookMallList({
        majorId: this.activeMajorId,
        pageNo: 1,
        pageSize: 3,
      }).then((res) => {
        this.bookList = res.data.result.records;
      });
    },
    openBanner(item) {
      console.log(item);
      if (item.clickEvent == 1) {
        window.open(item.skipUrl);
      } else if (item.clickEvent == 2) {
        let origin = "course";
        const { href } = this.$router.resolve({
          path: "/courseDetail",
          query: {
            id: item.skipUrl,
            origin: origin,
          },
        });

        window.open(href, "_blank");
      } else if (item.clickEvent == 3) {
        let origin = "faceCourse";
        const { href } = this.$router.resolve({
          path: "/courseDetail",
          query: {
            id: item.skipUrl,
            origin: origin,
          },
        });
        window.open(href, "_blank");
      } else if (item.clickEvent == 4) {
        if (item.jumpPosition == 1) {
          const { href } = this.$router.resolve({
            path: "/bookMall",
            query: {
              id: item.skipUrl,
              jumpPosition: item.jumpPosition,
            },
          });
          window.open(href, "_blank");
        } else if (item.jumpPosition == 2) {
          const { href } = this.$router.resolve({
            path: "/bookMall",
            query: {
              id: item.skipUrl,
              jumpPosition: item.jumpPosition,
            },
          });
          window.open(href, "_blank");
        } else {
          const { href } = this.$router.resolve({
            path: "/bookDetail",
            query: {
              id: item.skipUrl,
            },
          });
          window.open(href, "_blank");
        }
      }
    },
    // 显示客服二维码
    showContact() {
      this.$alert(
        `<img src="${this.contactImg}" style="width: 60%;height: auto;display: block;margin: 0 auto;" />`,
        "微信扫一扫联系客服",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "关闭",
        }
      );
    },
    // 试听直播
    toLive(item, index) {
      this.indexOfL = index;
      console.log(item);
      let token = window.localStorage.getItem("token");
      if (token) {
        if (item.liveClassroomStatus == 1) {
          this.getLiveUrl(item);
        } else if (item.liveClassroomStatus == 2) {
          this.getLiveUrl(item);
        } else if (item.liveClassroomStatus == 3) {
          this.$message("回放暂未生成");
        } else {
          this.getLiveUrl(item);
        }
      } else {
        this.$router.push("/login");
      }
    },
    getLiveUrl(item) {
      let userid = window.localStorage.getItem("userInfo")
        ? JSON.parse(window.localStorage.getItem("userInfo")).id
        : "";
      getLiveUrl({
        userid: userid,
        channelId: item.channel,
      }).then((res) => {
        console.log(res);
        if (res.data.result && res.data.result.url) {
          addCourseRecord({
            courseId: item.id,
            isType: 2,
          });
          window.open(res.data.result.url);
        }
      });
    },
    toInformation(item) {
      window.open("https://yixue.wendu.com/zixun/" + item.id + ".html");
      // const {
      //   href
      // } = this.$router.resolve({
      //   path: "/testPreparationInformationDetail",
      //   query: {
      //     id: item.id,
      //   },
      // });
      // window.open(href, "_blank");
      // window.open('/testPreparationInformationDetail?id=' + item.id)
    },
    toCourse(item, origin) {
      const { href } = this.$router.resolve({
        path: "/courseDetail",
        query: {
          id: item.id,
          origin: origin,
        },
      });
      window.open(href, "_blank");
      // window.open('/courseDetail?id=' + item.id)
    },
    // 专业师资
    getTeacher() {
      getTeacherList({
        pageSize: 9,
        majorId: this.activeMajorId,
      }).then((res) => {
        let data = res.data.result.records;
        if (res.data.result.records.length > 0) {
          if (data.length <= 3) {
            this.teacherList.push(data.splice(0));
          } else if (data.length > 3 && data.length <= 6) {
            this.teacherList.push(data.splice(0, 3));
            this.teacherList.push(data.splice(0));
          } else {
            this.teacherList.push(data.splice(0, 3));
            this.teacherList.push(data.splice(0, 3));
            this.teacherList.push(data.splice(0));
          }
        }
      });
    },
    // 学员评价
    getStudentCommentList() {
      getStudentCommentList().then((res) => {
        if (res.data.code == 200 && res.data.result.records.length > 0) {
          let data = res.data.result.records;
          if (data.length <= 4) {
            this.StudentCommentList.push(data.splice(0));
          } else if (data.length > 4 && data.length <= 8) {
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0));
          } else if (data.length > 8 && data.length <= 12) {
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0));
          } else if (data.length > 12 && data.length <= 16) {
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0));
          } else if (data.length > 16) {
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0, 4));
            this.StudentCommentList.push(data.splice(0));
          }
        }
      });
    },
    // 获取直播预告列表
    getAuditionLivePageList(activeMajorId) {
      getAuditionLivePageList(activeMajorId).then((res) => {
        if (res.data.code == 200) {
          if (res.data.result.records.length > 0) {
            this.auditionLivePageList = res.data.result.records;
            this.auditionLivePageNum = Math.ceil(
              res.data.result.records.length / 3
            );
          } else {
            this.auditionLivePageList = [];
            this.auditionLivePageNum = 0;
            // this.$message('当前专业下暂无试听直播')
          }
        }
      });
    },
    // 获取试听直播列表
    getCourseapiList(activeMajorId, index) {
      getCourseapiList(activeMajorId).then((res) => {
        if (res.data.code == 200) {
          console.log(res.data.result.records);
          if (res.data.result.records.length > 0) {
            this.auditionLivePageNumqwe = res.data.result.pages;
            this.CourseapiList = res.data.result.records;
            // res.data.result.records.forEach((res, index) => {
            //   this.CourseapiList.push(res);
            // });
            if (index == 1) {
              console.log("进入");
              setTimeout(() => {
                console.log(this.$refs.videoListScrolls);
                this.$refs.videoListScrolls.style.webkitTransform = `translate(0, ${0}px) scale(1) translateZ(0px)`;
              }, 100);
            }
            if (this.player) {
              this.player.destroy();
            }
          } else {
            // this.CourseapiList = [];
            this.obj2.pageNo = res.data.result.pages;

            // this.auditionLivePageNum = 0;
            this.$message("当前专业下暂无更多试听直播");
          }
        }
      });
    },
    // 获取 试听 课程列表
    getAuditionCoursePageList(activeMajorId, index) {
      console.log(activeMajorId, 213);

      getAuditionCoursePageList(activeMajorId).then((res) => {
        if (res.data.code == 200) {
          console.log(res.data, 2222);
          if (res.data.result.records.length > 0) {
            this.auditionCoursePageList = [];
            this.auditionCoursePageNum = res.data.result.pages;
            this.auditionCoursePageList = res.data.result.records;
            // res.data.result.records.forEach((res, index) => {
            //   this.auditionCoursePageList.push(res);
            // });

            if (index == 1) {
              console.log("进入");
              setTimeout(() => {
                console.log(this.$refs.videoListScroll);
                this.$refs.videoListScroll.style.webkitTransform = `translate(0, ${0}px) scale(1) translateZ(0px)`;
              }, 100);
            }
            console.log(this.auditionCoursePageList);
            // 试听课程列表请求成功后初始化发播放器
            this.num = 1;

            this.vid = this.auditionCoursePageList[0].vid;
            this.getPolyvFindByToken(this.auditionCoursePageList[0]);
          } else {
            // this.auditionCoursePageList = [];
            // this.auditionCoursePageNum = 0;
            // if (this.player) {
            //   this.player.destroy();
            // }
            this.obj.pageNo = res.data.result.pages;
            this.$message("当前专业下暂无更多试听课程");
          }
        }
      });
    },
    // 获取保利威视频token
    getPolyvFindByToken(data) {
      if (!data.vid) {
        this.$message("试听课程回放不存在");
        return;
      }
      getPolyvFindByToken({
        courseId: data.id,
      }).then((res) => {
        if (res.data.code == 200 && res.data.result) {
          this.vid = data.vid;
          if (this.player) {
            this.player.destroy();
          }
          this.player = polyvPlayer({
            wrap: "#player",
            width: 622,
            height: 350,
            vid: data.vid,
            playsafe: res.data.result.token,
            df: 3,
            showHd: false,
          });
        }
      });
    },
    changePlayer(data) {
      this.getPolyvFindByToken(data);
    },

    // 获取 系列 课程列表
    getSeriesCoursePageList(activeMajorId) {
      getSeriesCoursePageList(activeMajorId, {
        pageSize: 3,
        pageNo: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.result.records.length > 0) {
            this.seriesCoursePageList = res.data.result.records;
          } else {
            this.seriesCoursePageList = [];
            // this.$message('当前专业下暂无系列课程')
          }
        }
      });
    },
    // 获取 面授 课程列表
    getFaceCoursePageList(activeMajorId) {
      getFaceCoursePageList(activeMajorId, {
        pageSize: 3,
        pageNo: 1,
      }).then((res) => {
        if (res.data.code == 200) {
          if (res.data.result.records.length > 0) {
            this.faceCoursePageList = res.data.result.records;
          } else {
            this.faceCoursePageList = [];
            // this.$message('当前专业下暂无面授课程')
          }
        }
      });
    },
    // 专业父级切换
    handleClick(tab, event) {
      if (this.player) {
        this.player.destroy();
      }
      this.auditionCoursePageList = [];
      this.CourseapiList = [];

      this.activeMajorId = this.majorList[tab.index].wdResourcesMajorList[0].id;
      setMajorId(this.activeMajorId);
      this.getAuditionLivePageList(this.activeMajorId);
      // this.obj2.majorId = this.activeMajorId
      // this.getCourseapiList(this.obj2);
      this.obj.majorId = this.activeMajorId;
      this.getAuditionCoursePageList(this.obj);

      this.getSeriesCoursePageList(this.activeMajorId);
      this.getFaceCoursePageList(this.activeMajorId);
      this.getTeacher();
      this.num = 1;
    },
    // 专业子级切换
    majorChange(activeMajorId) {
      console.log(activeMajorId);
      if (this.player) {
        this.player.destroy();
      }
      this.activeMajorId = activeMajorId;
      this.auditionCoursePageList = [];
      this.CourseapiList = [];
      setMajorId(activeMajorId);
      this.getAuditionLivePageList(activeMajorId);
      // this.obj2.majorId = this.activeMajorId
      // this.getCourseapiList(this.obj2);
      this.obj.majorId = this.activeMajorId;
      this.getAuditionCoursePageList(this.obj);
      this.getSeriesCoursePageList(this.activeMajorId);
      this.getFaceCoursePageList(this.activeMajorId);
      this.num = 1;
    },
    pageLeft() {
      // 试听直播向左翻页
      if (!this.isLivePageScrollNow) {
        this.isLivePageScrollNow = !this.isLivePageScrollNow;
        if (this.livePage > 1) {
          this.$refs.liveListscroll.style.transition =
            "-webkit-transform 900ms ease-in";
          this.$refs.liveListscroll.style.webkitTransform = `translate(${
            this.livePageLeft + 1314
          }px,0) scale(1) translateZ(0px)`;
          this.livePageLeft = this.livePageLeft + 1314;
          setTimeout(() => {
            this.livePage--;
            this.isLivePageScrollNow = !this.isLivePageScrollNow;
          }, 900);
        } else {
          this.$message("没有更多了");
          this.isLivePageScrollNow = !this.isLivePageScrollNow;
        }
      }
    },
    pageRight() {
      // 试听直播向右翻页
      if (!this.isLivePageScrollNow) {
        this.isLivePageScrollNow = !this.isLivePageScrollNow;
        if (this.livePage < this.auditionLivePageNum) {
          this.$refs.liveListscroll.style.transition =
            "-webkit-transform 900ms ease-in";
          this.$refs.liveListscroll.style.webkitTransform = `translate(${
            this.livePageLeft - 1314
          }px,0) scale(1) translateZ(0px)`;
          this.livePageLeft = this.livePageLeft - 1314;
          setTimeout(() => {
            this.livePage++;
            this.isLivePageScrollNow = !this.isLivePageScrollNow;
          }, 900);
        } else {
          this.$message("没有更多了");
          this.isLivePageScrollNow = !this.isLivePageScrollNow;
        }
      }
    },
    videoListUpDown(type) {
      console.log(this.isVideoPageScrollNow);
      // 试听课程左右翻页
      if (!this.isVideoPageScrollNow) {
        this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
        if (type == 1) {
          if (this.num == 1) {
            if (this.videoPage > 1) {
              console.log(12341);
              // this.$refs.videoListScroll.style.transition =
              //   "-webkit-transform 900ms ease-in";
              // this.$refs.videoListScroll.style.webkitTransform = `translate(0, ${this
              //   .videoPageTop + 352}px) scale(1) translateZ(0px)`;
              // this.videoPageTop = this.videoPageTop + 352;
              this.videoPage--;
              this.obj.majorId = this.activeMajorId;
              this.obj.pageNo--;
              this.getAuditionCoursePageList(this.obj);
              setTimeout(() => {
                this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
              }, 900);
            } else {
              this.$message("没有更多了");
              this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
            }
          } else {
            if (this.videoPage > 1) {
              // this.$refs.videoListScrolls.style.transition =
              //   "-webkit-transform 900ms ease-in";
              // this.$refs.videoListScrolls.style.webkitTransform = `translate(0, ${this
              //   .videoPageTop + 352}px) scale(1) translateZ(0px)`;
              // this.videoPageTop = this.videoPageTop + 352;
              this.videoPage--;
              this.obj2.majorId = this.activeMajorId;
              this.obj2.pageNo--;
              this.getCourseapiList(this.obj2);
              setTimeout(() => {
                this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
              }, 900);
            } else {
              this.$message("没有更多了");
              this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
            }
          }
        } else {
          if (this.num == 1) {
            if (this.videoPage < this.auditionCoursePageNum) {
              // this.$refs.videoListScroll.style.transition =
              // "-webkit-transform 900ms ease-in";
              // this.$refs.videoListScroll.style.webkitTransform = `translate(0, ${this
              // .videoPageTop - 352}px) scale(1) translateZ(0px)`;
              // this.videoPageTop = this.videoPageTop - 352;
              this.videoPage++;
              this.obj.majorId = this.activeMajorId;
              this.obj.pageNo++;
              this.getAuditionCoursePageList(this.obj);
              setTimeout(() => {
                this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
              }, 900);
            } else {
              this.$message("没有更多了");
              this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
            }
          } else {
            if (this.videoPage < this.auditionLivePageNumqwe) {
              // this.$refs.videoListScrolls.style.transition =
              //   "-webkit-transform 900ms ease-in";
              // this.$refs.videoListScrolls.style.webkitTransform = `translate(0, ${this
              //   .videoPageTop - 352}px) scale(1) translateZ(0px)`;
              // this.videoPageTop = this.videoPageTop - 352;
              this.videoPage++;
              this.obj2.majorId = this.activeMajorId;
              this.obj2.pageNo++;
              this.getCourseapiList(this.obj2);
              setTimeout(() => {
                this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
              }, 900);
            } else {
              this.$message("没有更多了");
              this.isVideoPageScrollNow = !this.isVideoPageScrollNow;
            }
          }
        }
      }
    },

    loadPlayerScript(callback) {
      if (!window.polyvPlayer) {
        const myScript = document.createElement("script");
        myScript.setAttribute("src", this.vodPlayerJs);
        myScript.onload = callback;
        document.body.appendChild(myScript);
      } else {
        callback();
      }
    },
  },
  destroyed() {
    if (this.player) {
      this.player.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
.el-tabs >>> .el-tabs__nav {
  // background: red !important;
  padding-bottom: 10px;
}

// 修改标签页表头样式
.el-tabs >>> .el-tabs__nav-prev {
  // background: red;
  margin-top: 3px;
}

.el-tabs >>> .el-icon-arrow-right {
  // background: red;
  margin-top: 10px;
}

.liveBoxenter {
  position: absolute;
  top: 30%;
  left: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: -80px;

  img {
    width: 61px;
    height: 61px;
    margin-bottom: 30px;
  }

  div {
    width: 160px;
    height: 50px;
    background: linear-gradient(0deg, #524dee 0%, #0cb6fd 100%);
    border-radius: 25px;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
}

.liveBoxFlex2 {
  width: 56px;
  height: 25px;
  background: linear-gradient(0deg, #09bbfe 0%, #5a42ec 100%);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 11px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  left: 12px;
}

.liveBoxFlex {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 30px;
  background: linear-gradient(0deg, #09bbfe 0%, #5a42ec 100%);
  border-radius: 4px;
  position: absolute;
  top: 13px;
  left: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;

  img {
    width: 19px;
    height: 19px;
    margin-right: 11px;
  }
}

.liveBox {
  width: 622px;
  height: 350px;
  background: #ffffff;
  position: relative;
  margin-right: 17px;
  cursor: pointer;
  display: flex;
  justify-content: center;

  .teacherImagePhoto {
    // width: 622px;
    height: 350px;
  }
}

.qiehuan {
  display: flex;
  margin-top: 6px;
  margin-left: 36px;
}

.shipin {
  font-size: 18px;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
  cursor: pointer;
}

.shipin2 {
  font-size: 18px;
  font-weight: 500;
  color: rgba(61, 125, 255, 1);
}

.border {
  width: 1px;
  height: 17px;
  border-right: 1px solid rgba(102, 102, 102, 1);
  margin-left: 15px;
  margin-right: 15px;
}

.zhibo {
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;

  color: rgba(102, 102, 102, 1);
}

.zhibo2 {
  font-size: 18px;
  font-weight: 500;
  color: rgba(61, 125, 255, 1);
}

.vytisb {
  width: 70px;
  height: 30px;
  border: 1px solid;
  border-image: linear-gradient(0deg, #ff7436, #ff8d45) 10 10;
  background: linear-gradient(0deg, #ff7436 0%, #ff8d45 100%);
  border-radius: 2px;
  background: #fff;
  line-height: 28px;
  text-align: center;
  color: RGBA(255, 116, 54, 1);
  font-size: 14px;
  font-weight: 400;
  margin: 30px 30px 38px 0; // display: flex;
  // align-items: center;
  // justify-content: center;
}

.bow {
  margin-bottom: 40px;
}

.tabs {
  .el-tabs__item {
    padding: 0;
    padding: 0 31px !important;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    position: relative;
    height: 70px;
  }

  .el-tabs__item.is-active {
    font-size: 18px;
    color: #3d7dff;
    font-weight: bold;

    &::after {
      position: absolute;
      width: 26px;
      height: 3px;
      background: #3d7dff;
      content: "";
      display: block;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .el-tabs__active-bar {
    display: none;
  }

  .el-tabs__nav-wrap::after {
    height: 1px;
    background-color: #e5e8ee;
  }
}

.home-View {
  .majorSelectBox {
    background-color: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    padding: 20px 20px 0;
    margin-top: 24px;
  }

  .majorBtnList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 10px;
    // padding: 0 14px 0;

    .majorButton {
      padding: 0 6px;
      width: 160px;
      height: 40px;
      background: #f5f6f9;
      border-radius: 4px;
      line-height: 40px;
      text-align: center;
      margin-right: 15px;
      font-size: 15px;
      font-family: Microsoft YaHei;
      color: #666666;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 25px;
    }

    .activeMajorId {
      color: #ffffff;
      background: #3d7dff;
    }
  }

  .homeTop {
    display: flex;
    justify-content: space-between;

    .banner {
      width: 970px;
    }

    .small {
      width: 970px;
      height: 380px;
      background-color: #99a9bf;
      font-size: 88px;
      text-align: center;
      line-height: 380px;
    }

    .PreparationNews {
      width: 970px;
      border-radius: 4px;
      background-color: #ffffff;
      margin-top: 23px;

      .PreparationNews-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 27px 0 22px;
        height: 65px;
        border-bottom: 1px solid #f1f2f4;

        img {
          width: 45px;
          height: 27px;
          margin-right: 7px;
        }

        a {
          font-size: 16px;
          font-family: Microsoft YaHei;
          color: #999999;
        }

        span {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
        }
      }

      .PreparationNews-content {
        width: 100%;
        height: 245px;
        max-height: 245px;
        padding: 35px 0 3px;
        // display: flex;
        // align-items: flex-start;
        // justify-content: flex-start;
        // flex-wrap: wrap;
        overflow: hidden;

        > div {
          float: left;
          width: 33.333%;
          height: 22px;
          padding-left: 27px;
          padding-right: 10px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;

          img {
            width: 11px;
            height: 9px;
            margin-right: 13px;
          }

          p {
            font-size: 15px;
            font-family: Microsoft YaHei;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          p:hover {
            color: rgb(61, 125, 255);
          }
        }
      }
    }

    .homeTop-r {
      width: 297px;

      .contactCodeImg {
        width: 297px;
        height: 257px;
        border-radius: 4px 4px 0 0;
        overflow: hidden;
        display: none;
        position: absolute;
        background-color: #ffffff;
        top: 0;
        left: 0;

        p {
          width: 100%;
          text-align: center;
          color: #333333;
          font-size: 15px;
          line-height: 40px;
          font-weight: bold;
          height: 40px;
        }

        img {
          width: auto;
          height: 217px;
          display: block;
          margin: 0 auto;
        }
      }

      .contactBox {
        position: relative;
      }

      .contactBox:hover .contactCodeImg {
        display: block;
      }

      .menuList {
        width: 100%;
        height: 210px;
        background-color: #ffffff;
        border-radius: 0px 0px 4px 4px;
        padding: 23px 14px 12px;
        display: flex;
        flex-wrap: wrap;

        > a:hover div {
          color: rgb(61, 125, 255);
        }

        > a {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 33.333%;

          img {
            width: 46px;
            height: 46px;
            margin-bottom: 8px;
          }

          div {
            width: 100%;
            display: block;
            padding: 0 6px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #666666;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
          }
        }

        > div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 18px;

          a {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              width: 46px;
              height: 46px;
              margin-bottom: 12px;
            }

            span {
              font-size: 14px;
              font-family: Microsoft YaHei;
              color: #666666;
            }
          }
        }
      }
    }
  }
  .top {
    margin-bottom: 22px;
    display: flex;
    // align-items: center;

    img {
      width: 130px;
      height: 35px;
    }
  }

  .AuditionCourse {
    padding-top: 40px;
    margin-bottom: 40px;
    position: relative;

    .top {
      margin-bottom: 22px;
      display: flex;
      // align-items: center;

      img {
        width: 130px;
        height: 35px;
      }
    }

    .AuditionCourseContent {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;

      .videoBox {
        width: 622px;
        height: 350px;
        border-radius: 4px;
        overflow: hidden;
        margin-right: 18px;
        background-image: url(../../assets/42428e3e25aff5ee85120a1f0fbddf2.png);
        background-size: 100% 100%;
      }

      .videoListUp {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -54px) scale(0.8);
        transition: transform 0.3s;
        z-index: 999;
      }

      .videoListDown {
        position: absolute;
        right: 0;
        top: 48%;
        z-index: 999;
        transform: translate(0, 2px) scale(0.8);
        transition: transform 0.3s;
      }

      .videoListUp:hover {
        transform: translate(0, -54px) scale(0.9);
      }

      .videoListDown:hover {
        transform: translate(0, 2px) scale(0.9);
      }

      .videoList2 {
        flex: 1;
        height: 350px;
        position: relative;
        overflow: hidden;
        z-index: 99;

        .videoListScrolls {
          width: 100%;
          height: 350px;
          display: flex;
          padding: 3px 0;
          // justify-content: space-between;
          flex-wrap: wrap;
        }

        .videoItem:hover {
          transform: translate(0, -4px);
          box-shadow: 0px 4px 8px #bdbdbd;
        }

        .videoItem {
          transition: transform 0.2s;
          width: 29.333%;
          height: 164px;
          margin-left: 0.5%;
          margin-right: 0.5%;
          border-radius: 4px;
          margin-bottom: 12px;
          overflow: hidden;

          .btmText {
            width: 100%;
            height: 60px;
            padding: 10px 16px;
            background-color: #ffffff;

            span {
              font-size: 14px;
              font-family: Microsoft YaHei;
              color: #666666;
              line-height: 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }

          .topImg {
            width: 100%;
            height: 104px;
            background: #ffffff;
            position: relative;
            display: flex;
            justify-content: center;

            .play {
              width: 40px;
              height: 40px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-20px, -20px);
            }

            .cover {
              // width: 100%;
              height: 100%;
            }
          }
        }
      }

      .videoList {
        flex: 1;
        height: 350px;
        position: relative;
        overflow: hidden;
        z-index: 99;

        .videoListScroll {
          width: 100%;
          height: 350px;
          display: flex;
          padding: 3px 0;
          // justify-content: space-between;
          flex-wrap: wrap;
        }

        .videoItem:hover {
          transform: translate(0, -4px);
          box-shadow: 0px 4px 8px #bdbdbd;
        }

        .videoItem {
          transition: transform 0.2s;
          width: 29.333%;
          height: 164px;
          margin-left: 0.5%;
          margin-right: 0.5%;
          border-radius: 4px;
          margin-bottom: 12px;
          overflow: hidden;

          .btmText {
            width: 100%;
            height: 60px;
            padding: 10px 16px;
            background-color: #ffffff;

            span {
              font-size: 14px;
              font-family: Microsoft YaHei;
              color: #666666;
              line-height: 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }

          .topImg {
            width: 100%;
            height: 104px;
            position: relative;

            .play {
              width: 40px;
              height: 40px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-20px, -20px);
            }

            .cover {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .AuditionLive {
    padding-top: 40px;
    position: relative;

    .pageLeft {
      position: absolute;
      top: calc(10px + 50%);
      left: 6px;
      width: 36px;
      height: 36px;
      transition: transform 0.3s;
      z-index: 999;
      opacity: 0.5;
    }

    .pageRight {
      position: absolute;
      top: calc(10px + 50%);
      right: 6px;
      width: 36px;
      height: 36px;
      transition: transform 0.3s;
      z-index: 999;
      opacity: 0.5;
    }

    .pageLeft:hover {
      transform: scale(1.2);
      opacity: 1;
    }

    .pageRight:hover {
      transform: scale(1.2);
      opacity: 1;
    }

    .top {
      margin-bottom: 22px;

      img {
        width: 127px;
        height: 36px;
      }
    }

    .AuditionLiveList {
      width: 100%;
      height: 238px;
      overflow: hidden;
      position: relative;

      .AuditionLiveList-scroll {
        width: auto;
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
      }

      .liveList-item {
        width: 416px !important;
        height: 238px;
        background: #ffffff;
        box-shadow: 0px 3px 10px 0px #e7e7e7;
        border-radius: 4px;
        padding: 25px 14px;
        display: flex;
        margin-right: 22px;

        > img {
          width: 190px;
          height: 190px;
          margin-right: 18px;
        }

        .right {
          width: 180px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .bottom {
            display: flex;
            justify-content: flex-end;

            .btn {
              margin: 0;
              width: 80px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              background: linear-gradient(90deg, #3a95fb 0%, #31b1ec 100%);
              border-radius: 2px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              color: #ffffff;
            }
          }

          .top {
            flex-direction: column;
            .kcName {
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: bold;
              color: #333333;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin-bottom: 16px;
            }

            .tName {
              font-size: 15px;
              font-family: Microsoft YaHei;
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-bottom: 22px;
            }

            .time {
              display: flex;
              align-items: center;
              font-size: 15px;
              font-family: Microsoft YaHei;
              color: #999999;

              > img {
                width: 18px;
                height: 18px;
                margin-right: 10px;
              }
            }
          }
        }
      }
    }

    .pageInfo {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-top: 27px;

      > div {
        width: 10px;
        height: 10px;
        background: #ced5e0;
        border-radius: 50%;
        margin: 0 6px;
      }

      .active {
        width: 44px;
        height: 10px;
        background: #3d7dff;
        border-radius: 5px;
      }
    }
  }

  .seriesCourses {
    width: 100%;
    background-color: #ffffff;
    padding: 40px 0;
    margin-top: 40px;

    .top {
      margin-bottom: 22px;

      img {
        width: 127px;
        height: 36px;
      }
    }
  }

  .faceCourse {
    padding: 40px 0 0;
    margin-bottom: 40px;
  }

  .seriesCoursesContent {
    width: 100%;
    display: flex;
    align-items: center;

    .leftImg {
      position: relative;
      overflow: hidden;
      margin-right: 25px;
      width: 240px;

      > img {
        width: 240px;
        height: 470px;
        transition: transform 0.5s;
      }

      p {
        width: 160px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #ffffff;
        box-shadow: 0px 3px 18px 0px rgba(38, 100, 220, 0.25);
        border-radius: 25px;
        position: absolute;
        bottom: 60px;
        left: 40px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #3d7dff;
      }
    }

    .rightCon {
      flex: 1;
      overflow: hidden;
      padding: 6px 0;

      display: flex;
      align-items: center;

      // justify-content: space-between;
      .item:hover {
        transform: translate(0, -4px);
        box-shadow: 0px 4px 8px #bdbdbd;
      }

      .item {
        transition: transform 0.5s;
        width: 32.333%;
        border-radius: 4px;
        margin: 0 0.5%;
        height: 470px;
        overflow: hidden;
        border: 1px solid #e5e8ee;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;

        .topImg {
          width: 100%;
          // height: 220px;
        }

        .bottom {
          flex: 1;
          display: flex;
          padding: 0 20px;
          justify-content: space-between;
          align-items: center;
        }

        .center {
          width: 100%;
          background-color: #ffffff;
          padding: 22px 20px;
          border-bottom: 1px solid #f0f1f5;

          .title {
            font-size: 18px;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 28px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }

          .dsc {
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #999999;
            margin: 20px 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }

          .teacherList {
            width: 100%;
            display: flex;
            align-items: center;

            .year {
              width: 68px;
              height: 32px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              font-size: 14px;
              font-family: Microsoft YaHei;
              color: #666666;
              border-left: 1px solid #edeff5;
            }

            .list {
              flex: 1;
              overflow: hidden;
              height: 32px;
              display: flex;
              align-items: center;

              > img {
                width: 32px;
                height: 32px;
                margin-right: 12px;
                border-radius: 16px;
              }
            }
          }
        }
      }
    }
  }

  .supportingInformation {
    padding: 40px 0;

    .seriesCoursesContent {
      display: flex;

      .leftImg {
        > img {
          height: 422px;
          margin-right: 25px;
        }
      }

      .rightCon {
        flex: 1;
        // display: flex;
        // justify-content: space-between;
      }

      .item {
        height: 400px;
        height: 422px;
        padding: 20px;
        background-color: #ffffff;
        position: relative;

        .topImg {
          width: 100%;
          height: 240px;
          line-height: 240px;
          text-align: center;
          background: #dbf2ff;

          > img {
            width: 194px;
            height: 222px;
          }
        }

        .center {
          border: 0;
          padding: 30px 0 18px;

          .boolName {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #333333;
            line-height: 26px;
            margin-bottom: 30px;
          }

          .bookprice {
            position: absolute;
            bottom: 20px;
            left: 20px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #fa642c;

            span {
              font-size: 24px;
            }
          }
        }
      }
    }
  }

  .home-lunbo {
    width: 100%;
    background-color: #ffffff;
    padding: 40px 0;
    margin-top: 40px;

    .top {
      margin-bottom: 22px;
    }

    .lunboView-content {
      display: flex;
      justify-content: space-between;

      .leftImg {
        position: relative;

        > img {
          width: 240px;
          height: 470px;
          // margin-right: 25px;
        }

        p {
          width: 160px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          background: #ffffff;
          box-shadow: 0px 3px 18px 0px rgba(38, 100, 220, 0.25);
          border-radius: 25px;
          position: absolute;
          bottom: 60px;
          left: 40px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #3d7dff;
        }
      }

      .lunbo-teachers-left {
        width: 1051px;
        margin-left: 25px;
        height: 100%;
      }

      // 样式重写
      .el-carousel {
        height: 450px;
      }

      .el-carousel__indicator {
        padding-bottom: 0;

        button {
          width: 10px;
          height: 10px;
          background: #ced5e0;
          border-radius: 50%;
        }
      }

      .el-carousel__indicator.is-active {
        button {
          width: 44px;
          height: 10px;
          background: #3d7dff;
          border-radius: 5px;
        }
      }

      // **********************************
      .teachers-list {
        display: flex;
        // justify-content: space-between;

        .teachers-item {
          width: 33.333%;
          border-radius: 4px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .teachers-img {
            width: 280px;
            height: 280px;
          }

          .context {
            // position: absolute;
            // bottom: 0;
            // left: 50%;
            // transform: translateX(-50%);
            width: 291px;
            height: 131px;
            background: #ffffff;
            border: 1px solid #e5e8ee;
            border-radius: 4px;
            box-sizing: border-box;
            padding: 25px 32px 10px 21px;

            .teacher-name {
              .name {
                width: 44px;
                height: 22px;
                font-size: 22px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 26px;
                margin-right: 9px;
              }

              .academicDegree {
                font-size: 14px;
                font-family: Microsoft YaHei;

                font-weight: 400;
                color: #666666;
                line-height: 26px;
              }
            }

            .teacher-text {
              font-family: Microsoft YaHei;
              font-size: 14px;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

  .aboutwd {
    width: 100%;
    padding: 40px 0 20px;
    background-color: #ffffff;

    .title {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      margin-bottom: 22px;
    }

    .liaojie {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #3d7dff;
      border: 1px solid #3d7dff;
      border-radius: 2px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #ffffff;
      margin-bottom: 50px;
    }

    .aboutwxContent {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;

      .left {
        padding-top: 10px;

        .line {
          width: 60px;
          height: 2px;
          background: linear-gradient(90deg, #3d7dff, #3dc6ff);
          margin-bottom: 40px;
        }

        > div {
          font-size: 16px;
          font-family: Microsoft YaHei;
          color: #333333;
          line-height: 30px;
          opacity: 0.78;
          width: 513px;
        }
      }

      .line {
        width: 1px;
        height: 138px;
        background: #eff1f4;
      }

      .right {
        width: 643px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .r-item {
          display: flex;
          flex-direction: column;
          align-items: center;

          > img {
            width: 116px;
            height: 77px;
            margin-bottom: 30px;
          }

          > div {
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #3d7dff;
            margin-bottom: 20px;

            span {
              font-size: 42px;
              font-family: Avanti;
              font-weight: bold;
              color: #3d7dff;
            }
          }

          p {
            width: 100%;
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #666666;
          }
        }
      }
    }

    // **********************************
    .assess-list {
      width: 100%;
      display: flex;
      // justify-content: space-between;
      padding: 0 8px;

      .assess-item {
        width: 24%;
        margin: 0 0.5%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .teachers-img {
          width: 76px;
          height: 76px;
          border-radius: 50%;
          z-index: 5;
        }

        .content {
          width: 100%;
          height: 210px;
          background: #ffffff;
          box-shadow: 0px 5px 16px 0px rgba(206, 211, 212, 0.4);
          border-radius: 4px;
          transform: translate(0, -38px);
          z-index: 1;
          padding: 54px 30px 40px;

          .username {
            width: 100%;
            text-align: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            color: #999999;
            padding-bottom: 26px;
          }

          .line {
            width: 29px;
            height: 2px;
            background: linear-gradient(90deg, #3d7dff, #3dc6ff);
            margin: 0 auto 25px;
          }

          .text {
            width: 100%;
            text-align: center;
            font-size: 16px;
            font-family: Microsoft YaHei;
            color: #666666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }
  }

  .btn {
    width: 100%;
    height: 50px;
    margin: 30px 0 38px;
    background: #3d7dff;
    border-radius: 4px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ffffff;
    line-height: 50px;
    text-align: center;
  }

  .bindPhoneDialog {
    width: 100%;
    // min-width: 520px !important;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 0 35px;
  }

  .phoneCode {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 22px;
    border: 1px solid #e5e8ee;
    border-radius: 4px;
    padding: 0 20px;
    box-sizing: border-box;

    input {
      flex: 1;
      height: 50px;
      box-sizing: border-box;
      font-size: 16px;
      color: #333333;
    }

    input::placeholder {
      font-size: 16px;
      font-family: Microsoft YaHei;
      color: #999999;
    }

    p {
      height: 24px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      color: #3d7dff;
      padding-left: 20px;
      border-left: 1px solid #e5e8ee;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index/index.vue